import { ReactNode } from 'react';

import { clsx } from 'clsx';

import { useTabs } from '../Tabs';
import cls from './Tab.module.scss';

type TabProps = {
  children: ReactNode;
  className?: string;
  value: number | string;
  ariaLabel?: string;
  activeClassName?: string;
  variant?: 'default' | 'accent';
  onClick?: (tab: string) => void;
};

export const Tab = ({ children, className, value, ariaLabel, activeClassName, onClick }: TabProps) => {
  const { activeTab, setActiveTab } = useTabs();

  const handleClick = () => {
    const val = value.toString();

    setActiveTab(val);
    onClick?.(val);
  };

  return (
    <button
      aria-label={ariaLabel || ''}
      onClick={handleClick}
      className={clsx(cls.wrap, className, { [clsx(cls.active, activeClassName)]: activeTab === value.toString() })}
    >
      {children}
    </button>
  );
};
